import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import { useNavigate } from 'react-router-dom';

/** Màn hình cho tài khoản Google đã tạo nhưng Admin chưa duyệt. */
export function PendingApproval(): JSX.Element {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        p: 2,
      }}
    >
      <Paper elevation={3} sx={{ p: 4, width: '100%', maxWidth: 460, borderRadius: 3 }}>
        <Stack spacing={2} alignItems="center" textAlign="center">
          <HourglassTopIcon color="warning" sx={{ fontSize: 48 }} />
          <Typography variant="h5" fontWeight={700}>
            Tài khoản đang chờ duyệt
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Chúng tôi đã tạo tài khoản cho bạn và đã thông báo cho quản trị viên.
            Bạn sẽ đăng nhập được ngay sau khi tài khoản được kích hoạt.
          </Typography>
          <Button variant="outlined" onClick={() => navigate('/login', { replace: true })}>
            Quay lại trang đăng nhập
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
}
